import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import { useLocation } from "react-router-dom";

export default function Layout({
  children,
  center = true,
  footer = true,
}: {
  children: React.ReactNode;
  center?: boolean;
  footer?: boolean;
}) {
  const location = useLocation();

  return (
    <div
      className={`${
        footer ? "h-screen" : "min-h-screen"
      } flex flex-col w-full h-full`}
    >
      <div className="sticky top-0 z-30">
        <Header />
      </div>
      <div
        key={location.pathname}
        className={`flex-1 ${center ? "container mx-auto" : ""}`}
      >
        {children}
      </div>
      {footer && <Footer />}
    </div>
  );
}
